import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import ForgotResetPage from "../../components/authentication/ForgotResetPage";
import * as authActions from "../../state/actions/authActions.js";

class ForgotResetcontainer extends Component {
    render() {
        const { t, password, repeatPassword, history, match, changeValue, reset } = this.props;

        const { user, token } = match.params;

        return (
            <ForgotResetPage
                {...this.props}
                onChange={changeValue}
                onReset={() => {
                    reset(user, token, password, repeatPassword, t).then(() => {
                        history.push("/login");
                    });
                }}
            />
        );
    }
}

function mapStateToProps(state) {
    return {

        error: state.auth.error,
        password: state.auth.password,
        repeatPassword: state.auth.repeatPassword,
        isFetching: state.auth.isFetching,
        isAuthenticated: state.auth.isAuthenticated,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        reset: (user, token, password, repeatPassword, t) =>
            dispatch(authActions.reset(user, token, password, repeatPassword, t)),
        changeValue: (name, value) => dispatch(authActions.changeResetValue(name, value)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation("translation")(ForgotResetcontainer));
